<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="col-md-6 offset-md-3">
            <h5 class="card-title text-center mb-4">Agregar nuevo usuario</h5>

            {{ form }}
            <b-form @submit.stop.prevent="onSubmit">
              <b-form-group label-cols-sm="2" label="Email" label-for="input-email">
                <b-form-input
                  id="input-email"
                  name="input-email"
                  type="email"
                  v-model="$v.form.email.$model"
                  :state="validateState('email')"
                ></b-form-input>
                <b-form-invalid-feedback id="input-email-live-feedback">El email es requerido.</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label-cols-sm="2" label="Nombre" label-for="input-name">
                <b-form-input
                  id="input-name"
                  name="input-name"
                  type="text"
                  v-model="$v.form.name.$model"
                  :state="validateState('name')"
                ></b-form-input>
                <b-form-invalid-feedback id="input-name-live-feedback">El nombre es requerido.</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                label-cols-sm="2"
                label="Apellido Paterno"
                label-for="input-last-name-1"
              >
                <b-form-input
                  id="input-last-name-1"
                  name="input-last-name-1"
                  type="text"
                  v-model="$v.form.lastName1.$model"
                  :state="validateState('lastName1')"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="input-last-name-1-live-feedback"
                >El apellido paterno es requerido.</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                label-cols-sm="2"
                label="Apellido Materno"
                label-for="input-last-name-2"
              >
                <b-form-input
                  id="input-last-name-2"
                  name="input-last-name-2"
                  type="text"
                  v-model="$v.form.lastName2.$model"
                  :state="validateState('lastName2')"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="input-last-name-2-live-feedback"
                >El apellido materno es requerido.</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label-cols-sm="2" label="Empresa" label-for="input-enterprise">
                <b-form-select
                  id="input-enterprise"
                  v-model="$v.form.enterprise_id.$model"
                  :state="validateState('enterprise_id')"
                  :options="enterpriseOptions"
                ></b-form-select>
                <b-form-invalid-feedback
                  id="input-enterprise-live-feedback"
                >Debes seleccionar una empresa.</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label-cols-sm="2" label="Rol" label-for="input-role">
                <b-form-select
                  id="input-role"
                  v-model="$v.form.role_id.$model"
                  :state="validateState('role_id')"
                  :options="roleOptions"
                ></b-form-select>
                <b-form-invalid-feedback id="input-role-live-feedback">Debes seleccionar un rol.</b-form-invalid-feedback>
              </b-form-group>

              <div class="form-group row mt-5">
                <div class="col-sm-12">
                  <b-button type="submit" variant="primary" block>Registrar</b-button>
                </div>
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosAdelaService from '@/axios/axiosAdelaService'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import {
  BForm,
  BButton,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormInvalidFeedback
} from 'bootstrap-vue'
import formatData from '@/mixins/formatAxios'

export default {
  mixins: [validationMixin, formatData],
  components: {
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BFormSelect
  },
  data () {
    return {
      form: {
        email: null,
        name: null,
        lastName1: null,
        lastName2: null,
        enterprise_id: null,
        role_id: null
      },
      enterpriseOptions: [],
      roleOptions: []
    }
  },
  validations: {
    form: {
      email: {
        required
      },
      name: {
        required
      },
      lastName1: {
        required
      },
      lastName2: {
        required
      },
      enterprise_id: {
        required
      },
      role_id: {
        required
      }
    }
  },
  methods: {
    validateState (name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    async onSubmit () {
      try {
        this.$v.form.$touch()
        if (this.$v.form.$anyError) {
          return
        }
        const request = {
          ...this.form
        }
        console.log('request', request)
        const response = await axiosAdelaService.post('/registerNewUser', request)
        console.log('registerNewUser', response)
        if (response.status === 200) {
          this.$toastedPush({
            message: response.data.msg,
            type: 'success'
          })
          this.$router.push({ name: 'users' })
        }
      } catch (error) {
        this.showError('No se pudo registrar el nuevo usuario intentalo mas tarde.')
      }
    }
  },
  async mounted () {
    try {
      const enterpriseResponse = await axiosAdelaService.post('/enterprisesselect')
      console.log('enterpriseResponse', enterpriseResponse)
      console.log(enterpriseResponse)
      if (enterpriseResponse.status === 200) {
        this.enterpriseOptions = this.$_.map(enterpriseResponse.data.rows, (enterprise) => {
          return {
            value: enterprise.id,
            text: enterprise.name
          }
        })
      }
      const roleResponse = await axiosAdelaService.post('/rolesselect')
      console.log('roleResponse', roleResponse)
      if (roleResponse.status === 200) {
        this.roleOptions = this.$_.map(roleResponse.data, (role) => {
          return {
            value: role.id,
            text: role.name
          }
        })
      }
    } catch (error) {
      this.showError('No se pudieron obtener los datos intentalo mas tarde.')
    }
  }
}
</script>

<style>

</style>
